export default __webpack_public_path__ + "static/media/incidents.4681314a.svg";